export default "/static/favicon/ef7cc04ef94e06fece58adb4c849cc0e.svg";